<div *ngIf="!!formattedDate">
  <span class="align-middle me-2">{{ formattedDate }}</span>
  <button
    class="btn btn-sm btn-secondary align-middle"
    [title]="('cellRendererCopyToClipboard' | localize)"
    (click)="clipboardService.copy(formattedDate)">
    <i class="fa fa-copy"></i>
  </button>
</div>
